import { defineMessages } from "react-intl";

export const variantDetailsChannelsAvailabilityCardMessages = defineMessages({
  title: {
    id: "sedoZ3",
    defaultMessage: "Availability",
    description: "VariantDetailsChannelsAvailabilityCard title",
  },
  subtitle: {
    id: "3+KwtP",
    defaultMessage: "Available in {publishedInChannelsCount} out of {availableChannelsCount}",
    description: "VariantDetailsChannelsAvailabilityCard subtitle",
  },
  itemSubtitlePublished: {
    id: "0ReyKr",
    defaultMessage: "Published since {publishedAt}",
    description: "VariantDetailsChannelsAvailabilityCard item subtitle published",
  },
  itemSubtitleHidden: {
    id: "EsZH44",
    defaultMessage: "Hidden",
    description: "VariantDetailsChannelsAvailabilityCard item subtitle hidden",
  },
  noItemsAvailable: {
    id: "jqJqdE",
    defaultMessage: "This variant is not available at any of the channels",
    description: "VariantDetailsChannelsAvailabilityCard no items available",
  },
  manageButtonText: {
    id: "2CBcub",
    defaultMessage: "Manage",
    description: "CreateVariantTitle manage",
  },
  variantForSaleLabel: {
    id: "sKcA25",
    defaultMessage: "For sale in this channel",
    description: "variant channel availability - listing toggle label",
  },
  itemSubtitleProductPublished: {
    id: "7S8/G2",
    defaultMessage: "Product published since {publishedAt}",
    description: "variant channel availability - product publication status",
  },
  itemSubtitleProductNotPublished: {
    id: "c/wG44",
    defaultMessage: "Product not published",
    description: "variant channel availability - product publication status hidden",
  },
  variantForSaleTooltip: {
    defaultMessage:
      "Controls whether this variant is offered for sale in this channel. Turning it off removes the variant's price here, so it disappears from the storefront. This is per-variant and separate from whether the product is published.",
    id: "zIi6kn",
    description: "variant channel availability - listing toggle tooltip",
  },
  productPublicationTooltip: {
    defaultMessage:
      "Publication is set for the whole product, per channel, on the product page — not per variant. A variant is only sold when the product is published here and the variant is also listed for sale.",
    id: "Ocgbs2",
    description: "variant channel availability - product publication tooltip",
  },
});
